export default {
      id: "sbp-btn-blue-usage",
      viewBox: "0 0 60 32",
      url: __webpack_public_path__ + "svgsprite.svg#sbp-btn-blue",
      toString: function () {
        return this.url;
      }
    }